import { forwardRef } from 'react';
import clsx from 'clsx';
import {
  IconButton as LibraryIconButton,
  ButtonSizes,
  IconButtonVariants,
  IconButtonModes,
  type IconButtonVariantsType
} from 'stubben-edge-unified-frontend-react-components';
import type { IconButtonProps } from './types';

function mapToLibraryVariant(
  legacyVariant: IconButtonProps['variant'],
  color: string | undefined
): IconButtonVariantsType {
  const v = legacyVariant ?? 'ghost';
  if (v === 'outlined') return IconButtonVariants.Secondary;
  if (v === 'filled') return IconButtonVariants.Primary;
  if (v === 'text') return IconButtonVariants.Link;
  if (color === 'primary') return IconButtonVariants.Primary;
  return IconButtonVariants.Ghost;
}

const IconButton = forwardRef<HTMLElement, IconButtonProps>(function IconButton(
  props,
  ref
) {
  const {
    className,
    children,
    loading,
    rounded = true,
    variant: legacyVariant = 'ghost',
    color = 'default',
    size: legacySize,
    ...rest
  } = props;

  const variant = mapToLibraryVariant(legacyVariant, color);

  let size: (typeof ButtonSizes)[keyof typeof ButtonSizes] = ButtonSizes.MD;
  if (legacySize === 'small' || legacySize === 'xs') size = ButtonSizes.SM;
  else if (legacySize === 'large') size = ButtonSizes.LG;

  const cls = styleIconButton(props);

  return (
    <LibraryIconButton
      ref={ref}
      className={clsx(cls.main, className)}
      variant={variant}
      mode={IconButtonModes.Normal}
      size={size}
      loading={loading}
      rounded={rounded !== false}
      {...rest}
    >
      {children}
    </LibraryIconButton>
  );
});

export default IconButton;

function styleIconButton(props: IconButtonProps) {
  const mc = 'IconButton';
  const cls = {
    main: [mc]
  };
  if (props.rounded !== undefined) {
    switch (props.rounded) {
      case 'full':
        cls.main.push(`${mc}--rounded-full`);
        break;
      case true:
        cls.main.push(`${mc}--rounded`);
        break;
      case false:
        cls.main.push(`${mc}--rounded-none`);
        break;
    }
  }
  return cls;
}
